import { render, staticRenderFns } from "./CustomValidationExampleModal.vue?vue&type=template&id=fa484486&scoped=true&"
import script from "./CustomValidationExampleModal.vue?vue&type=script&lang=ts&"
export * from "./CustomValidationExampleModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomValidationExampleModal.vue?vue&type=style&index=0&id=fa484486&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa484486",
  null
  
)

export default component.exports